import React, {useEffect} from "react";
import {Col, Grid, Row} from "react-flexbox-grid";
import {
  AbsoluteDiv,
  AbsoluteDivStage, BorderContainerLower, CalendarDatesContainer, CalendarPageContainer, Dates, Description,
  OperatorPageContainer,
  StageContainer, StageTitle
} from "../Style/CalendarPage/CalendarPage";
import {Breadcrumb, Breadcrumbs} from "react-breadcrumbs";
import {BreadcrumbsItem, BreadcrumbsItemLink, DocumentsPageContent} from "../Style/DocumentsPage/DocumentsPage";
import {DisplayFlex, PageTitle} from "../Style/Pages";



const datesFederal = [
  {
    date: "1 октября – 15 октября",
    desc: "Сбор заявок от участников"
  },
  {
    date: "1 октября – 6 ноября",
    desc: "Предоставление конкурсных материалов"
  },
  {
    date: "7 ноября – 29 ноября",
    desc: "Экспертиза предоставленных на Конкурс материалов, формирование рейтингового списка участников Конкурса"
  },
  {
    date: "30 ноября – 10 декабря",
    desc:
      "Подведение итогов Конкурса, утверждение результатов Учредителем Конкурса."
  }
];


export const CalendarPage = () => {

  useEffect(() => {
    window.scrollTo(0, 0)
  })

  return (
    <CalendarPageContainer>
      <DocumentsPageContent>
      <Grid fluid>
        <Row>
          <Col lg={12}>
            <Breadcrumbs separator={' / '}>
              <Breadcrumb data={{
                title: <BreadcrumbsItem>Главная страница</BreadcrumbsItem>,
                pathname: '/'
              }}/>
              <Breadcrumb data={{
                title: <BreadcrumbsItemLink>Календарь</BreadcrumbsItemLink>,
                pathname: '/calendar'
              }}/>
            </Breadcrumbs>
          </Col>
          <Row>
            <Col lg={12}>
              <DisplayFlex>
                <PageTitle>календарь</PageTitle>
              </DisplayFlex>
            </Col>
          </Row>
        </Row>
        <OperatorPageContainer>
          <Row>
            <Col lg={1} />
            <Col lg={10}>
              {/*<BorderContainer>*/}
              {/*  <StageContainer>*/}
              {/*    <AbsoluteDivStage color="#1795b1" />*/}
              {/*    <StageTitle>*/}
              {/*      Региональный этап и организационные мероприятия*/}
              {/*    </StageTitle>*/}
              {/*    <Dates>1 АПРЕЛЯ - 13 ОКТЯБРЯ</Dates>*/}
              {/*  </StageContainer>*/}
              {/*  {dates.map(item => (*/}
              {/*    <CalendarDatesContainer key={item.desc}>*/}
              {/*      <AbsoluteDiv color="#1795b1" />*/}
              {/*      <Dates>{item.date}</Dates>*/}
              {/*      <Description>{item.desc}</Description>*/}
              {/*    </CalendarDatesContainer>*/}
              {/*  ))}*/}
              {/*</BorderContainer>*/}
              <BorderContainerLower>
                <StageContainer style={{ marginTop: "70px" }}>
                  <AbsoluteDivStage color="#f6a117" />
                  <StageTitle>этапы и организационные мероприятия</StageTitle>
                  <Dates>1 октября - 10 декабря</Dates>
                </StageContainer>
                {datesFederal.map((item, _) => (
                  <CalendarDatesContainer key={new Date().toString() + _}>
                    <AbsoluteDiv color="#f6a117" />
                    <Dates>{item.date}</Dates>
                    <Description>{item.desc}</Description>
                  </CalendarDatesContainer>
                ))}
              </BorderContainerLower>
            </Col>
            <Col lg={1} />
          </Row>

      </OperatorPageContainer>
      </Grid>
      </DocumentsPageContent>
    </CalendarPageContainer>
  )
}